import React from 'react';
import styled from 'styled-components';
import { Box, Icon } from '@chakra-ui/react';

// Styled component for the footer
const FooterContainer = styled.div`
  color: white;
  padding: 20px;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 85px; // 여백 조정
`;

const FooterWrapper = styled.div`
  display: flex;
  width: 466px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const Title = styled.h1`
  color: #fff;
  text-align: center;
  font-size: 96px;
  font-weight: 300;
  line-height: normal;
  letter-spacing: 0.3px;

  @media (max-width: 1024px) {
    font-size: 64px;
  }

  @media (max-width: 768px) {
    font-size: 40px;
  }
`;

const Text = styled.p`
  font-size: 20px;
  max-width: 400px;
  text-align: center;
  @media (max-width: 1024px) {
    font-size: 17px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const IconBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 142px;
  gap: 30px;
  @media (max-width: 1024px) {
    margin-top: 71px;
  }

  @media (max-width: 768px) {
    margin-top: 64px;
  }
`;

const CopyrightText = styled.p`
  font-size: 16px;
  margin-top: 44px;
  color: rgba(255, 255, 255, 0.7);
  @media (max-width: 1024px) {
    margin-top: 28px;
    font-size: 14px;
  }

  @media (max-width: 768px) {
    margin-top: 20px;
    font-size: 12px;
  }
`;

const BottomMargin = styled.div`
  margin-top: 108px;

  @media (max-width: 1024px) {
    margin-top: 80px;
  }

  @media (max-width: 768px) {
    margin-top: 50px;
  }
`;

const Footer: React.FC<{ language: string }> = ({ language }) => {
  return (
    <FooterContainer>
      <FooterWrapper>
        <Title>SOULX</Title>
        <Text>
          {language === 'EN'
            ? 'Guaranteeing the freedom of space and expression to all storytellers in the world'
            : '세상의 모든 스토리텔러들에게 공간과 소통의 자유를 주다.'}
        </Text>
      </FooterWrapper>
      <IconBox>
        <a href="https://www.linkedin.com/company/teamsoulx/" target="_blank" rel="noopener noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
          <path d="M25.9273 0H2.06719C0.924219 0 0 0.902344 0 2.01797V25.9766C0 27.0922 0.924219 28 2.06719 28H25.9273C27.0703 28 28 27.0922 28 25.982V2.01797C28 0.902344 27.0703 0 25.9273 0ZM8.30703 23.8602H4.15078V10.4945H8.30703V23.8602ZM6.22891 8.67344C4.89453 8.67344 3.81719 7.59609 3.81719 6.26719C3.81719 4.93828 4.89453 3.86094 6.22891 3.86094C7.55781 3.86094 8.63516 4.93828 8.63516 6.26719C8.63516 7.59062 7.55781 8.67344 6.22891 8.67344ZM23.8602 23.8602H19.7094V17.3633C19.7094 15.8156 19.682 13.8195 17.5492 13.8195C15.3891 13.8195 15.0609 15.5094 15.0609 17.2539V23.8602H10.9156V10.4945H14.8969V12.3211H14.9516C15.5039 11.2711 16.8602 10.1609 18.8781 10.1609C23.0836 10.1609 23.8602 12.9281 23.8602 16.5266V23.8602Z" fill="white"/>
          </svg>
        </a>
        <a href="https://www.instagram.com/studio.xroom/" target="_blank" rel="noopener noreferrer">
<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
<path d="M14 2.52109C17.7406 2.52109 18.1836 2.5375 19.6547 2.60312C21.0219 2.66328 21.7602 2.89297 22.2523 3.08438C22.9031 3.33594 23.3734 3.64219 23.8602 4.12891C24.3523 4.62109 24.6531 5.08594 24.9047 5.73672C25.0961 6.22891 25.3258 6.97266 25.3859 8.33437C25.4516 9.81094 25.468 10.2539 25.468 13.9891C25.468 17.7297 25.4516 18.1727 25.3859 19.6438C25.3258 21.0109 25.0961 21.7492 24.9047 22.2414C24.6531 22.8922 24.3469 23.3625 23.8602 23.8492C23.368 24.3414 22.9031 24.6422 22.2523 24.8938C21.7602 25.0852 21.0164 25.3148 19.6547 25.375C18.1781 25.4406 17.7352 25.457 14 25.457C10.2594 25.457 9.81641 25.4406 8.34531 25.375C6.97813 25.3148 6.23984 25.0852 5.74766 24.8938C5.09688 24.6422 4.62656 24.3359 4.13984 23.8492C3.64766 23.357 3.34687 22.8922 3.09531 22.2414C2.90391 21.7492 2.67422 21.0055 2.61406 19.6438C2.54844 18.1672 2.53203 17.7242 2.53203 13.9891C2.53203 10.2484 2.54844 9.80547 2.61406 8.33437C2.67422 6.96719 2.90391 6.22891 3.09531 5.73672C3.34687 5.08594 3.65313 4.61562 4.13984 4.12891C4.63203 3.63672 5.09688 3.33594 5.74766 3.08438C6.23984 2.89297 6.98359 2.66328 8.34531 2.60312C9.81641 2.5375 10.2594 2.52109 14 2.52109ZM14 0C10.1992 0 9.72344 0.0164062 8.23047 0.0820312C6.74297 0.147656 5.72031 0.388281 4.83437 0.732812C3.91016 1.09375 3.12813 1.56953 2.35156 2.35156C1.56953 3.12812 1.09375 3.91016 0.732812 4.82891C0.388281 5.72031 0.147656 6.7375 0.0820313 8.225C0.0164063 9.72344 0 10.1992 0 14C0 17.8008 0.0164063 18.2766 0.0820313 19.7695C0.147656 21.257 0.388281 22.2797 0.732812 23.1656C1.09375 24.0898 1.56953 24.8719 2.35156 25.6484C3.12813 26.425 3.91016 26.9062 4.82891 27.2617C5.72031 27.6062 6.7375 27.8469 8.225 27.9125C9.71797 27.9781 10.1937 27.9945 13.9945 27.9945C17.7953 27.9945 18.2711 27.9781 19.7641 27.9125C21.2516 27.8469 22.2742 27.6062 23.1602 27.2617C24.0789 26.9062 24.8609 26.425 25.6375 25.6484C26.4141 24.8719 26.8953 24.0898 27.2508 23.1711C27.5953 22.2797 27.8359 21.2625 27.9016 19.775C27.9672 18.282 27.9836 17.8062 27.9836 14.0055C27.9836 10.2047 27.9672 9.72891 27.9016 8.23594C27.8359 6.74844 27.5953 5.72578 27.2508 4.83984C26.9062 3.91016 26.4305 3.12812 25.6484 2.35156C24.8719 1.575 24.0898 1.09375 23.1711 0.738281C22.2797 0.39375 21.2625 0.153125 19.775 0.0875C18.2766 0.0164063 17.8008 0 14 0Z" fill="white"/>
<path d="M14 6.80859C10.0297 6.80859 6.80859 10.0297 6.80859 14C6.80859 17.9703 10.0297 21.1914 14 21.1914C17.9703 21.1914 21.1914 17.9703 21.1914 14C21.1914 10.0297 17.9703 6.80859 14 6.80859ZM14 18.6648C11.4242 18.6648 9.33516 16.5758 9.33516 14C9.33516 11.4242 11.4242 9.33516 14 9.33516C16.5758 9.33516 18.6648 11.4242 18.6648 14C18.6648 16.5758 16.5758 18.6648 14 18.6648Z" fill="white"/>
<path d="M23.1547 6.52418C23.1547 7.45387 22.4 8.20309 21.4758 8.20309C20.5461 8.20309 19.7969 7.4484 19.7969 6.52418C19.7969 5.5945 20.5516 4.84528 21.4758 4.84528C22.4 4.84528 23.1547 5.59996 23.1547 6.52418Z" fill="white"/>
</svg>
        </a>
        <a href="https://www.youtube.com/@soulx2167" target="_blank" rel="noopener noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20" viewBox="0 0 28 20" fill="none">
          <path d="M27.7211 4.40004C27.7211 4.40004 27.4477 2.46957 26.6055 1.62191C25.5391 0.506287 24.3469 0.500818 23.8 0.435193C19.8844 0.150818 14.0055 0.150818 14.0055 0.150818H13.9945C13.9945 0.150818 8.11562 0.150818 4.2 0.435193C3.65313 0.500818 2.46094 0.506287 1.39453 1.62191C0.552344 2.46957 0.284375 4.40004 0.284375 4.40004C0.284375 4.40004 0 6.66957 0 8.93363V11.0555C0 13.3196 0.278906 15.5891 0.278906 15.5891C0.278906 15.5891 0.552344 17.5196 1.38906 18.3672C2.45547 19.4829 3.85547 19.4446 4.47891 19.5649C6.72109 19.7782 14 19.8438 14 19.8438C14 19.8438 19.8844 19.8329 23.8 19.5539C24.3469 19.4883 25.5391 19.4829 26.6055 18.3672C27.4477 17.5196 27.7211 15.5891 27.7211 15.5891C27.7211 15.5891 28 13.325 28 11.0555V8.93363C28 6.66957 27.7211 4.40004 27.7211 4.40004ZM11.107 13.6313V5.76176L18.6703 9.71019L11.107 13.6313Z" fill="white"/>
        </svg>
        </a>
      </IconBox>
      <CopyrightText>© 2024 SOULX. All rights reserved.</CopyrightText>
      <BottomMargin />
    </FooterContainer>
  );
};

export default Footer;
